import React, { FC, useEffect } from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Box, Paper } from '@material-ui/core';
import Typo from '../../../Components/Typo';
import gsap, { TimelineMax } from 'gsap';
import { uniqueId } from 'lodash';
import Spinner from '../../../Components/Spinner';
import { useMediaQuery } from '../../../Hooks/useMediaQuery';

export interface HeroSectionProps {

}

const HeroSection: FC<HeroSectionProps> = (props) => {
    const classes = useStyles();
    const id = uniqueId('home-feature-label');
    const { isDeviceSm } = useMediaQuery();

    useEffect(() => {
        const tl = new TimelineMax({ repeat: -1 })
            .to(`#${`${id}-text1`}`, 1.5, { text: 'Virtual', ease: "power2.easeOut" })
            .to(`#${`${id}-text1`}`, 1, { text: '', ease: "power2.easeOut" }, '+=2')
            .to(`#${`${id}-text1`}`, 1.5, { text: 'In-Person', ease: "power2.easeOut" })
            .to(`#${`${id}-text1`}`, 1, { text: '', ease: "power2.easeOut" }, '+=2')
            .to(`#${`${id}-text1`}`, 1.5, { duration: 1, text: 'Hybrid', ease: "power2.easeOut" })
            .to(`#${`${id}-text1`}`, 1, { text: '', ease: "power2.easeOut" }, '+=2')
        tl.play();

        gsap.to(`.${classes.subtitle}`, { delay: 1, opacity: 1, top: 0, duration: 0.3, ease: "power2.easeOut" })

    }, [])

    return (
        <section>
            <Box display='flex' flexDirection='column' alignItems='center'>
                <Typo className={classes.title} variant='h2' weight='medium' align='center'>
                    Create and execute engaging <span id={`${id}-text1`}></span> events
            </Typo>
                <Box width={isDeviceSm ? '100vw' : '460px'} my={3} mx='auto'>
                    <Typo className={classes.subtitle} variant='h5' align='center'>
                        Exceptional Customer Experience through the event journey for the attendees
                </Typo>
                </Box>
                <Box my={2}>
                    <Spinner />
                </Box>
            </Box>
        </section>
    )
}

const useStyles = makeStyles<Theme, any>((theme) => ({
    title: {
        '& > span': {
            color: theme.palette.primary.main
        }
    },
    subtitle: {
        position: 'relative',
        opacity: 0,
        top: 20
    }
}));

export default HeroSection;